<template>
  <v-container v-if="access.includes(roles.biometrics)">
    <v-card
      class="mx-auto set-height"
    >
      <v-card-title>
        <v-btn
          text
          :class="{ selected: !file_view }"
          @click="file_view = false"
        >
          Data
        </v-btn>
        <v-btn
          text
          :class="{ selected: file_view }"
          @click="file_view = true"
        >
          Files
        </v-btn>
        <v-spacer />
        <v-col
          v-if="!file_view"
          cols="12"
          sm="6"
          md="4"
        >
          <v-text-field
            v-model="search_input"
            append-icon="mdi-magnify"
            label="Search"
            class="menu-items"
            @keydown.enter="OnSearchInput"
          />
        </v-col>
        <v-col
          v-if="!file_view"
          cols="12"
          sm="6"
          md="4"
        >
          <v-btn
            color="grey darken-2"
            outlined
            @click="ShowExport()"
          >
            Export to Excel
          </v-btn>
        </v-col>
      </v-card-title>
      <div>
        <v-data-table
          v-if="file_view"
          :headers="headers_biometrics_files"
          :items="biometrics_files"
          :options.sync="options2"
          :server-items-length="total2"
          :loading="loading_biometrics_files"
          :disable-sort="true"
          :loading-text="loading_text"
          class="elevation-1 text-no-wrap"
        >
          <template v-slot:[`item.file_size`]="{ item }">
            {{ (item.file_size!=null ? BytesToSize(Number(item.file_size)) : '-') }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              small
              color="primary"
              @click.stop="ViewFile(item.uid, item.file_name)"
            >
              View
            </v-btn>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ GetDateFormat(item.created_at) }}
          </template>
        </v-data-table>
        <v-data-table
          v-if="!file_view"
          :headers="headers_biometrics_data"
          :items="biometrics_data"
          :options.sync="options"
          :server-items-length="total"
          :loading="loading_biometrics_data"
          :disable-sort="true"
          :loading-text="loading_text"
          class="elevation-1 text-no-wrap"
        >
          <template v-slot:[`item.created_at`]="{ item }">
            {{ GetDateFormat(item.created_at) }}
          </template>
        </v-data-table>
      </div>
      <v-card-title>
        <div class="primary--text">
          Biometrics Summary
        </div>
      </v-card-title>
      <div>
        <v-row>
          <v-col>
            <v-sheet height="500">
              <v-progress-linear
                v-if="loading_summary"
                indeterminate
                color="primary"
              />
              <v-data-table
                :headers="headers_summary"
                :items="summary"
                :loading="loading_summary"
                :disable-sort="true"
                :loading-text="loading_text"
                hide-default-header
                class="elevation-1 text-no-wrap sticky"
              >
                <template v-slot:header="{ props }">
                  <thead
                    :class="{ hidden: loading_summary}"
                    class="v-data-table-header"
                  >
                    <tr>
                      <th
                        :class="{ 'text-center': true, title: true }"
                        rowspan="2"
                        style="border: thin solid rgba(0, 0, 0, 0.12);"
                      >
                        <span>Store</span>
                      </th>
                      <th
                        v-for="(header, index) in headers_summary2"
                        :key="header.value + index"
                        :class="{ 'text-center': true, title: true }"
                        colspan="2"
                        style="border-top: solid thin rgba(0, 0, 0, 0.12);
                          border-right: solid thin rgba(0, 0, 0, 0.12);
                          border-bottom: solid thin rgba(0, 0, 0, 0.12);
                        "
                      >
                        <span>{{ header.text }}</span>
                      </th>
                    </tr>
                    <tr>
                      <th
                        v-for="(header, index) in props.headers"
                        :key="header.text + index"
                        :class="{ 'text-start': true, title: true, hidden: (header.text === 'Store') }"
                        style="border-right: solid thin rgba(0, 0, 0, 0.12);
                          border-bottom: solid thin rgba(0, 0, 0, 0.12);
                        "
                      >
                        <span>{{ header.text }}</span>
                      </th>
                    </tr>
                  </thead>
                </template>
                <template v-slot:body="{ items, headers }">
                  <tr
                    v-for="(item, idx) in items"
                    :key="idx"
                    style="line-height: 12px !important;font-size: 12px !important;"
                  >
                    <td
                      v-for="(header,key) in headers"
                      :key="key"
                      style="border-right: solid thin rgba(0, 0, 0, 0.12);
                        border-bottom: solid thin rgba(0, 0, 0, 0.12);
                      "
                      :class="{ customgrid: header.value !=='Store' }"
                    >
                      <strong
                        v-if="header.value ==='Store'"
                      >
                        {{ item[header.value] }}
                      </strong>
                      <strong
                        v-if="header.value !=='Store' && item[header.value] === 0"
                        class="red--text"
                      >
                        {{ item[header.value] }}
                      </strong>
                      <v-chip
                        v-if="header.value !=='Store' && item[header.value] !== 0 && header.text === 'Crew'"
                        class="ma-2 text-center"
                        color="info"
                        style="margin:0px !important; padding:0 6px!important;"
                      >
                        {{ item[header.value] }}
                      </v-chip>
                      <v-chip
                        v-if="header.value !=='Store' && item[header.value] !== 0 && header.text === 'Hours'"
                        class="ma-2"
                        color="warning"
                        style="margin:0px !important; padding:0 6px!important;"
                      >
                        {{ item[header.value] }}
                      </v-chip>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <!-- File content dialog -->
    <v-dialog
      v-model="show_file_content"
      max-width="30%"
    >
      <v-card :loading="loading_file_content">
        <v-card-title class="text-left">
          <h2 class="primary--text">
            {{ file_name }}
          </h2>
        </v-card-title>
        <v-card-text>
          {{ file_content }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="show_file_content = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End file content dialog -->

    <!-- Export to Excel dialog -->
    <v-dialog
      v-model="show_export"
      width="40%"
      max-width="40%"
    >
      <v-card>
        <v-card-title class="text-left">
          <h2 class="primary--text">
            Export To Excel
          </h2>
        </v-card-title>
        <v-card-text>
          <v-col
            cols="12"
            sm="10"
          >
            <v-text-field
              v-model="personnelidno"
              clearable
              :counter="10"
              :rules="[
                v => v.length ==0 || (v.length == 10 && /^\d*$/.test(v)) || 'Must be 10 characters long, all numeric.'
              ]"
            >
              <template v-slot:label>
                <div>
                  PERSONNELIDNO <small>(optional)</small>
                </div>
              </template>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="10"
          >
            <v-menu
              v-model="date_menu_from"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date_from"
                  label="Date From"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="date_from"
                @input="OnDateInput"
              />
            </v-menu>
            <v-menu
              v-model="date_menu_to"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date_to"
                  label="Date To"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="date_to"
                @input="OnDateInput"
              />
            </v-menu>
          </v-col>
          <v-btn
            color="green darken-1"
            text
            plain
            style="text-decoration: underline;opacity:1;"
            :class="{ hidden: filename == ''}"
            :disabled="in_process"
            :href="filename"
            target="_blank"
            download
          >
            Download File
          </v-btn>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="generating"
            color="green darken-1"
            text
            loading
          />
          <v-btn
            color="green darken-1"
            text
            :disabled="generating"
            @click="ExportToExcel()"
          >
            Generate
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="generating"
            @click="show_export = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Export to Excel dialog -->
    <confirm ref="confirm" />
  </v-container>
</template>
<script>
  import moment from 'moment'
  import {
    mapState,
  } from 'vuex'
  import {
    BiometricsFiles,
    BiometricsData,
    GetFileContent,
    GetBiometricsSummary,
  } from '@/graphql/Biometrics.gql'
  import {
    ExportToExcel,
  } from '@/graphql/File.gql'
  export default {
    components: {
      Confirm: () => import('@/views/dashboard/component/Confirm'),
    },
    data () {
      return {
        file_view: false,
        biometrics_files: [],
        biometrics_data: [],
        summary: [],
        loading_text: 'Please wait while loading data...',
        headers_biometrics_files: [
          { text: 'Date', value: 'date', class: 'title' },
          { text: 'Filename', value: 'file_name', class: 'title' },
          { text: 'File Size', value: 'file_size', class: 'title', align: 'right' },
          { text: 'Date Created', value: 'created_at', class: 'title' },
          { text: 'Actions', value: 'actions', class: 'title' },
        ],
        headers_biometrics_data: [
          { text: 'PERSONNELIDNO', value: 'personnelidno', class: 'title' },
          { text: 'Crew Name', value: 'name', class: 'title' },
          { text: 'Reference Date', value: 'reference_date', class: 'title' },
          { text: 'Date IN', value: 'date_in', class: 'title' },
          { text: 'Date OUT', value: 'date_out', class: 'title' },
          { text: 'Time IN', value: 'time_in', class: 'title' },
          { text: 'Break OUT', value: 'break_out', class: 'title' },
          { text: 'Break IN', value: 'break_in', class: 'title' },
          { text: 'Time OUT', value: 'time_out', class: 'title' },
          { text: 'Hours', value: 'hours', class: 'title', align: 'right' },
          { text: 'Date Created', value: 'created_at', class: 'title' },
        ],
        headers_summary: [],
        headers_summary2: [],
        loading_summary: true,
        skip_summary: true,
        loading_biometrics_files: true,
        skip_biometrics_files: true,
        loading_biometrics_data: true,
        skip_biometrics_data: true,
        search: '',
        search_input: '',
        total: 0,
        options: {
          page: 1,
          itemsPerPage: 10,
        },
        total2: 0,
        options2: {
          page: 1,
          itemsPerPage: 10,
        },
        uid: '',
        biometrics_files_hash: '',
        file_name: '',
        file_content: '',
        loading_file_content: true,
        skip_file_content: true,
        show_file_content: false,
        show_export: false,
        filename: '',
        personnelidno: '',
        generating: false,
        date_menu_from: false,
        date_menu_to: false,
        date_from: moment().format('YYYY-MM-DD'),
        date_to: moment().format('YYYY-MM-DD'),
      }
    },
    computed: {
      ...mapState(['in_process', 'default_error', 'access', 'roles']),
    },
    watch: {
      options: {
        handler () {
          this.GetBiometricsData()
        },
        deep: true,
      },
      options2: {
        handler () {
          this.GetBiometricsFiles()
        },
        deep: true,
      },
    },
    mounted () {
      window.scrollTo(0, 0)
      this.GetBiometricsData()
      this.GetBiometricsSummary()
      this.GetBiometricsFiles()
    },
    methods: {
      GetHoursSpan (datein, dateout, timein, timeout) {
        const s = this.GetDateTimeSpan(
          datein + ' ' + this.FormatTime('0000'.substring(0, 4 - timein.length) + timein),
          dateout + ' ' + this.FormatTime('0000'.substring(0, 4 - timeout.length) + timeout),
        )
        return Math.round(s * 100) / 100
      },
      FormatTime (t) {
        return moment(t, 'HHmm').format('HH:mm')
      },
      GetDateFormat (d) {
        if (!d) { return '' }
        return moment(d).format('YYYY-MM-DD hh:mm A')
      },
      BytesToSize (bytes) {
        var sizes = ['B', 'KB', 'MB', 'GB', 'TB']
        if (bytes === 0) return '0 B'
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
      },
      OnSearchInput (e) {
        this.search = this.search_input
        this.options.page = 1
        this.GetBiometricsData()
      },
      GetBiometricsFiles () {
        this.loading_biometrics_files = true
        this.biometrics_files = []
        this.skip_biometrics_files = false
      },
      GetBiometricsData () {
        this.loading_biometrics_data = true
        this.biometrics_data = []
        this.skip_biometrics_data = false
      },
      GetBiometricsSummary () {
        this.summary = []
        this.headers_summary = []
        this.loading_summary = true
        this.skip_summary = false
        this.$apollo.queries.GetBiometricsSummary.refetch()
      },
      ViewFile (uid, f) {
        this.uid = uid
        this.file_name = f
        this.file_content = ''
        this.loading_file_content = true
        this.skip_file_content = false
        this.show_file_content = true
      },
      OnDateInput () {
        this.date_menu_from = false
        this.date_menu_to = false
      },
      ShowExport () {
        if (!this.access.includes(this.roles.biometrics_export)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.filename = ''
        this.personnelidno = ''
        this.date_from = moment().format('YYYY-MM-DD')
        this.date_to = moment().format('YYYY-MM-DD')
        this.show_export = true
      },
      ExportToExcel () {
        const biometrics = 211
        this.generating = true
        this.filename = ''
        this.$apollo.mutate({
          mutation: ExportToExcel,
          variables: {
            personnelidno: this.personnelidno,
            date_from: this.date_from,
            date_to: this.date_to,
            type: biometrics,
          },
        }).then((res) => {
          if (res.data.ExportToExcel.status === 'Ok') {
            this.filename = res.data.ExportToExcel.data[0].filename
          } else if (res.data.ExportToExcel.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.ExportToExcel.status)
          }
          this.generating = false
        }).catch(error => {
          this.CheckError(error)
          error = false
          this.generating = false
        })
      },
      ParseJSON (o) {
        try {
          return JSON.parse(o)
        } catch (e) {
          return ''
        }
      },
    },
    apollo: {
      GetFileContent: {
        error (error) {
          this.loading_file_content = false
          this.CheckError(error)
        },
        query: GetFileContent,
        variables () {
          return {
            uid: this.uid,
            hash: this.biometrics_files_hash,
          }
        },
        skip () {
          return this.skip_file_content
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data.GetFileContent.status === 'Ok') {
              this.file_content = data.GetFileContent.data
            } else if (data.GetFileContent.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.file_content = data.GetFileContent.status
            }
            this.loading_file_content = false
            this.skip_file_content = true
          }
        },
      },
      BiometricsFiles: {
        error (error) {
          this.loading_biometrics_files = false
          this.CheckError(error)
        },
        query: BiometricsFiles,
        variables () {
          return {
            per_page: this.options2.itemsPerPage || 10,
            page: this.options2.page || 1,
          }
        },
        skip () {
          return this.skip_biometrics_files
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data.BiometricsFiles && data.BiometricsFiles.data) {
              this.biometrics_files = data.BiometricsFiles.data
              this.biometrics_files_hash = data.BiometricsFiles.hash
              this.total2 = data.BiometricsFiles.total
              this.loading_biometrics_files = false
              this.skip_biometrics_files = true
            }
          }
        },
      },
      BiometricsData: {
        error (error) {
          this.loading_biometrics_data = false
          this.CheckError(error)
        },
        query: BiometricsData,
        variables () {
          return {
            per_page: this.options.itemsPerPage || 10,
            page: this.options.page || 1,
            search: this.search,
          }
        },
        skip () {
          return this.skip_biometrics_data
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data.BiometricsData && data.BiometricsData.status === 'Ok') {
              this.biometrics_data = data.BiometricsData.data
              this.total = data.BiometricsData.total
              this.loading_biometrics_data = false
              this.skip_biometrics_data = true
              // format values
              for (const index in this.biometrics_data) {
                var timein = this.biometrics_data[index].time_in
                var timeout = this.biometrics_data[index].time_out
                this.biometrics_data[index].time_in = (timein == null) ? '' : this.FormatTime('0000'.substring(0, 4 - timein.length) + timein)
                this.biometrics_data[index].time_out = (timeout == null) ? '' : this.FormatTime('0000'.substring(0, 4 - timeout.length) + timeout)
                //
                var breakin = this.biometrics_data[index].break_in
                var breakout = this.biometrics_data[index].break_out
                this.biometrics_data[index].break_in = (breakin == null) ? '' : this.FormatTime('0000'.substring(0, 4 - breakin.length) + breakin)
                this.biometrics_data[index].break_out = (breakout == null) ? '' : this.FormatTime('0000'.substring(0, 4 - breakout.length) + breakout)
                //
                this.biometrics_data[index].hours = ((timein == null) || (timeout == null)) ? '' : this.GetHoursSpan(this.biometrics_data[index].date_in, this.biometrics_data[index].date_out, timein, timeout)
              }
            } else if (data.BiometricsData.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            }
          }
        },
      },
      GetBiometricsSummary: {
        error (error) {
          this.loading_summary = false
          this.CheckError(error)
        },
        query: GetBiometricsSummary,
        variables () {
          return {
            date: moment().format('YYYY-MM-DD'),
          }
        },
        skip () {
          return this.skip_summary
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetBiometricsSummary) {
              this.loading_summary = false
              this.skip_summary = true
              var bio = this.ParseJSON(data.GetBiometricsSummary.data)
              var hasHeader = false
              for (const index in bio) {
                var item = {}
                for (var key in bio[index]) {
                  if (!hasHeader) {
                    if (key.toLowerCase() === 'store') {
                      this.headers_summary.push({
                        text: key, value: key, class: 'title',
                      })
                    } else {
                      this.headers_summary2.push({
                        text: key.replace('_', ' '), value: key, class: 'title',
                      })
                      this.headers_summary.push({
                        text: 'Crew', value: key + 'crew', class: 'title',
                      })
                      this.headers_summary.push({
                        text: 'Hours', value: key + 'hours', class: 'title',
                      })
                    }
                  }
                  if (key.toLowerCase() === 'store') {
                    item[key] = bio[index][key]
                  } else {
                    item[key + 'crew'] = bio[index][key][0]
                    item[key + 'hours'] = Math.round(bio[index][key][1])
                  }
                }
                this.summary.push(item)
                hasHeader = true
              }
            }
          }
        },
      },
    },
  }
</script>
